import { useState, useContext } from 'react';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { ThemeContext } from '@forma/forma-ui-kit';
import MetaTags from '@/components/MetaTags';
import FillingTemplateAndInformation from '@/components/blocks/FillingTemplateAndInformation';
import FillingInputEmailAndSend from '@/components/blocks/FillingInputEmailAndSend';
import useMetaTags from '@/hooks/useMetaTags';

const editorStylesUrl = process.env.REACT_APP_EDITOR_STYLES_URL;

const TemplatePage = (props) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { name, translatedName, description, seoMain, template, seoName } = props;

  const [dataFromRenderedTemplate, setDataFromRenderedTemplate] = useState([]);

  const nowYear = new Date().getFullYear();
  const titleTemplate = t('seo_title_template', { title: seoName ? seoName : name, year: nowYear });
  const descriptionFolder = t('seo_description_template', { title: seoName ? seoName : name, year: nowYear });
  const metaData = {
    title: titleTemplate,
    description: descriptionFolder,
    keywords: '',
    canonicalUrl: `${process.env.SITE_URL}${router.asPath}`,
  };
  const { lang } = useContext(ThemeContext);
  useMetaTags({ lang, ...metaData });

  return (
    <>
      <Head>
        <title>{metaData.title}</title>
        <MetaTags {...metaData} />
        <link type="text/css" rel="stylesheet" href={`${editorStylesUrl}?v=1.0.1`} />

      </Head>
      {!dataFromRenderedTemplate.id && (
        <FillingTemplateAndInformation
          key={router.asPath}
          onSetDataFromForm={setDataFromRenderedTemplate}
          template={{ name, description, translatedName, seoName }}
          {...props}
        />
      )}
      {dataFromRenderedTemplate.id && (
        <FillingInputEmailAndSend
          idRenderedTemplate={dataFromRenderedTemplate.id}
          firstImagePreviews={template.previews[0]}
        />
      )}
    </>
  );
};

export default TemplatePage;
